// Verbatim Edit-page copy that is duplicated across the two edit bodies, or
// net-new. Per-file labels stay at their call sites.

import {
  APPLICABLE_USER_FILE_LABEL,
  APPLICABLE_USER_FILE_TOOLTIP,
} from "../../../utils/constants";

// Re-exported, not duplicated: constants.js:5771-5772 stays the definition.
export { APPLICABLE_USER_FILE_LABEL, APPLICABLE_USER_FILE_TOOLTIP };

// ---- Published / shared status banners ----
export const EDIT_BANNER_PUBLISHED =
  "You have published this Trivvy and can no longer edit it.";
export const EDIT_BANNER_QUESTIONS_LOCKED =
  "Users have already taken this Trivvy. You can no longer edit the questions.";
export const EDIT_BANNER_SHARED =
  "This Trivvy has been shared and can no longer be edited.";

// ---- Published meta block (left column, Trivvy / KC only) ----
export const EDIT_PUBLISHED_ON_PREFIX = "This Trivvy was published on";
export const EDIT_APPLICABLE_USER_FILE_POPOVER_HEADER = "Applicable user file";
export const EDIT_FILE_UPLOADED_LABEL = "uploaded";
export const EDIT_VIEW_FILE_LINK = "(View File)";

// ---- Right column ----
export const EDIT_SEE_PREVIEW = "See Preview";

// Was an inline `<b>Suggestion:</b>` in both edit bodies; the mock renders it
// as a pill, so the colon moved out of the string.
export const EDIT_SUGGESTION_LABEL = "Suggestion";

export const EDIT_ADD_MEDIA = "Add media/images";

// ---- Top-left crumb label (when the doc is not in a folder) ----
export const EDIT_CRUMB_TRIVVY = "Trivvy";
export const EDIT_CRUMB_KNOWLEDGE_CHECK = "Knowledge Check";
export const EDIT_CRUMB_MESSAGES = "Messages";
